var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSliceIntelLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "200px",
    height: "181px",
    viewBox: "0 0 200 181",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "symbol") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "symbol"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-1",
    fill: "#5A5B58",
    points: "50.747651 69.357047 46.3932886 63.809396 93.9033557 26.5114094 98.2577181 32.0577181 50.747651 69.357047"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.069799,26.1395973 C127.069799,40.2241611 115.651007,51.642953 101.566443,51.642953 C87.4805369,51.642953 76.0630872,40.2241611 76.0630872,26.1395973 C76.0630872,12.0550336 87.4805369,0.636241611 101.566443,0.636241611 C115.651007,0.636241611 127.069799,12.0550336 127.069799,26.1395973",
    id: "Fill-2",
    fill: "#DF654F"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-3",
    fill: "#5A5B58",
    points: "45.0899329 101.990604 50.4724832 97.4348993 89.495302 143.54094 84.1127517 148.096644 45.0899329 101.990604"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4563758,77.8174497 C68.4563758,96.7208054 53.1315436,112.045638 34.2281879,112.045638 C15.3248322,112.045638 0,96.7208054 0,77.8174497 C0,58.914094 15.3248322,43.5892617 34.2281879,43.5892617 C53.1315436,43.5892617 68.4563758,58.914094 68.4563758,77.8174497",
    id: "Fill-4",
    fill: "#36A3AE"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-5",
    fill: "#5A5B58",
    points: "101.315436 96 102.092617 88.9919463 162.127517 95.6416107 161.351678 102.649664 101.315436 96"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-6",
    fill: "#5A5B58",
    points: "107.531544 150.390604 103.291275 144.755705 151.548993 108.42953 155.789262 114.063087 107.531544 150.390604"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.594631,153.880537 C122.594631,168.830872 110.475168,180.948993 95.5261745,180.948993 C80.5758389,180.948993 68.4563758,168.830872 68.4563758,153.880537 C68.4563758,138.930201 80.5758389,126.810738 95.5261745,126.810738 C110.475168,126.810738 122.594631,138.930201 122.594631,153.880537",
    id: "Fill-7",
    fill: "#DF654F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.104698,102.649664 C199.104698,121.55302 183.781208,136.877852 164.87651,136.877852 C145.973154,136.877852 130.648322,121.55302 130.648322,102.649664 C130.648322,83.7463087 145.973154,68.4214765 164.87651,68.4214765 C183.781208,68.4214765 199.104698,83.7463087 199.104698,102.649664",
    id: "Fill-8",
    fill: "#36A3AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.978523,89.6375839 C118.978523,100.016107 110.565101,108.42953 100.186577,108.42953 C89.8080537,108.42953 81.3946309,100.016107 81.3946309,89.6375839 C81.3946309,79.2590604 89.8080537,70.8456376 100.186577,70.8456376 C110.565101,70.8456376 118.978523,79.2590604 118.978523,89.6375839",
    id: "Fill-9",
    fill: "#F0AD52"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliceIntelLogo);
export default __webpack_public_path__ + "static/media/slice-intel-logo.1952a7597e692324208e2e0a1031c483.svg";
export { ForwardRef as ReactComponent };